import { LngLatBounds } from 'mapbox-gl';
import { type LngLat } from '../../types/Geo';
import { CustomRoutePath, CustomRouteWaypoint } from '../../types/CustomRoute';

export const getSegmentsBounds = (segmentsPaths: CustomRoutePath[][]) => {
  if (segmentsPaths.length === 0 || segmentsPaths[0].length === 0 || segmentsPaths[0][0].points.length === 0) {
    return;
  }

  const firstPoint = segmentsPaths[0][0].points[0];
  const firstLngLat = [firstPoint[1], firstPoint[0]] as LngLat;

  return segmentsPaths.reduce(
    (acc, segmentPaths) => {
      segmentPaths.forEach(path => {
        path.points.forEach(point => {
          acc.extend([point[1], point[0]]);
        });
      });
      return acc;
    },
    new LngLatBounds(firstLngLat, firstLngLat)
  );
};

export const getWaypointsBounds = (waypoints: CustomRouteWaypoint[]) => {
  if (waypoints.length === 0) {
    return;
  }

  const firstLngLat = [waypoints[0].longitude, waypoints[0].latitude] as LngLat;

  return waypoints.reduce(
    (acc, waypoint) => {
      acc.extend([waypoint.longitude, waypoint.latitude]);
      return acc;
    },
    new LngLatBounds(firstLngLat, firstLngLat)
  );
};
